var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"size":"xl","id":_vm.modalId,"hide-footer":"","hide-header":""}},[_c('div',[_c('button',{staticClass:"closeModal",on:{"click":function($event){return _vm.$bvModal.hide(_vm.modalId)}}},[_c('b-icon-x',{attrs:{"scale":"1.3"}})],1),_c('PaymentMethods',{on:{"listPaymentMethods":_vm.listPaymentMethods}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }